/**
 * URL canônica de uma página comum: host de produção + caminho da rota.
 *
 * Deriva de `route.path`, nunca de `route.fullPath`: a query string não faz
 * parte da identidade da página. Com `fullPath`, cada `?partner=154`,
 * `?utm_source=...`, `?fbclid=...` que chega de campanha vira uma canônica
 * própria — a URL declara a si mesma como canônica e o Google indexa a
 * variante com parâmetro em vez da URL limpa.
 *
 * Host de produção hardcoded para dev/staging nunca vazarem como canônica.
 * A barra final é removida para `/pt-br/videos/` e `/pt-br/videos` não
 * produzirem duas canônicas para a mesma página.
 *
 * Para as páginas de ensaio use `useModelCanonical` / `useModelSubpageCanonical`,
 * que consolidam o cluster em `/photo`.
 */
export function useCanonicalUrl(path?: string): string {
  const route = useRoute();
  const raw = path ?? route.path;
  const normalized = raw.length > 1 ? raw.replace(/\/+$/, "") : raw;
  return `https://belladasemana.com.br${normalized}`;
}
